const REACT_APP_ENV_TYPE = process.env.REACT_APP_ENV_TYPE;
const REACT_APP_ENV_URL = process.env.REACT_APP_ENV_URL;
const REACT_APP_ENV_LAYERSEVEN = process.env.REACT_APP_ENV_LAYERSEVEN;
const REACT_APP_HELP_AND_SUPPORT = process.env.REACT_APP_HELP_AND_SUPPORT;
const REACT_APP_API_SHIPMENT_GATEWAY = process.env.REACT_APP_API_SHIPMENT_GATEWAY;
const REACT_APP_API_EDD = process.env.REACT_APP_API_EDD;
const REACT_APP_API_POSTCODE_LOOKUP = process.env.REACT_APP_API_POSTCODE_LOOKUP;
const REACT_APP_API_LOCATIONS = process.env.REACT_APP_API_LOCATIONS;
const REACT_APP_AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
const REACT_APP_BRANCH_IO = process.env.REACT_APP_BRANCH_IO;

export const envConfig = {
  url: REACT_APP_ENV_URL ?? '',
  layerSeven: REACT_APP_ENV_LAYERSEVEN ?? '',
  type: REACT_APP_ENV_TYPE ?? '',
  helpAndSupport: REACT_APP_HELP_AND_SUPPORT ?? '',
  auth0ClientId: REACT_APP_AUTH0_CLIENT_ID ?? '',
};

export const apiKeys = {
  shipmentsGatewayAPI: REACT_APP_API_SHIPMENT_GATEWAY ?? '',
  eddAPI: REACT_APP_API_EDD ?? '',
  postcodeLookupAPI: REACT_APP_API_POSTCODE_LOOKUP ?? '',
  locationsAPI: REACT_APP_API_LOCATIONS ?? '',
  branchIO: REACT_APP_BRANCH_IO ?? '',
};

// Test env config invalidation
